// Shared service catalog used across landing + form + admin
export const SERVICES = [
  {
    id: "tyre_puncture",
    label: "Tyre Puncture Repair",
    short: "Puncture",
    tag: "01",
    blurb: "Flat on the highway? A tech reaches you with plugs, patches and a spare in minutes.",
    image:
      "https://images.unsplash.com/photo-1645445522156-9ac06bc7a767?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxjaGFuZ2luZyUyMGNhciUyMHRpcmUlMjBtZWNoYW5pY3xlbnwwfHx8fDE3ODU1MjI2NjZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "battery_jumpstart",
    label: "Battery Jump-Start",
    short: "Battery",
    tag: "02",
    blurb: "Dead battery at 2 AM? We carry heavy-duty jumpers and replacement cells on board.",
    image:
      "https://images.unsplash.com/photo-1597766370173-a14200ec0b42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxjYXIlMjBiYXR0ZXJ5JTIwanVtcGVyJTIwY2FibGVzfGVufDB8fHx8MTc4NTUyMjY2Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "vehicle_servicing",
    label: "Vehicle Servicing",
    short: "Servicing",
    tag: "03",
    blurb: "Doorstep servicing for any vehicle — oil, brakes, filters, diagnostics. Fully mobile.",
    image:
      "https://images.pexels.com/photos/4488639/pexels-photo-4488639.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "towing",
    label: "Towing & Recovery",
    short: "Towing",
    tag: "04",
    blurb: "Stuck or crashed? Flatbed and wheel-lift recovery to the garage of your choice.",
    image:
      "https://images.pexels.com/photos/8931963/pexels-photo-8931963.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "insurance",
    label: "Instant Insurance",
    short: "Insurance",
    tag: "05",
    blurb: "All-vehicle cover issued on the spot — third-party, comprehensive and zero-dep add-ons.",
    image:
      "https://images.unsplash.com/photo-1550517636-ad7bac40dc28?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxjYXIlMjBzdGVlcmluZyUyMHdoZWVsJTIwZHJpdmluZyUyMGZhc3R8ZW58MHx8fHwxNzg1NTIyNjc3fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1610374634235-b51ef357f905?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxjYXIlMjBuaWdodCUyMG5lb24lMjByb2FkJTIwZGFya3xlbnwwfHx8fDE3ODU1MjI2NzZ8MA&ixlib=rb-4.1.0&q=85";

export const VEHICLE_TYPES = [
  "Hatchback",
  "Sedan",
  "SUV",
  "Motorcycle",
  "Truck / Commercial",
  "Auto / Three-wheeler",
];

export const INSURANCE_PLANS = [
  {
    name: "Third-Party",
    price: "₹2,094",
    period: "/ year",
    features: ["Mandatory legal cover", "Third-party damage", "Instant e-policy", "24×7 claim helpline"],
    highlight: false,
  },
  {
    name: "Comprehensive",
    price: "₹6,499",
    period: "/ year",
    features: ["Own-damage + third-party", "Theft & fire cover", "Zero paperwork", "Cashless garages", "Roadside assist included"],
    highlight: true,
  },
  {
    name: "Zero-Dep Elite",
    price: "₹9,999",
    period: "/ year",
    features: ["Full parts value, no depreciation", "Engine protect", "Return-to-invoice", "Consumables cover", "Priority dispatch"],
    highlight: false,
  },
];

export const SERVICE_AREAS = ["Virar West", "Virar East"];

export const WHATSAPP_NUMBER = "919892648175";

export const buildWhatsAppLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const INSURANCE_TYPES = [
  { id: "2w", label: "2W Insurance", desc: "Bikes & scooters — third-party or comprehensive cover." },
  { id: "auto", label: "Auto Insurance", desc: "Three-wheeler autos with passenger permits." },
  { id: "car", label: "Car Insurance", desc: "Private cars — hatchback, sedan & SUV." },
  { id: "taxi", label: "Taxi Insurance", desc: "Commercial taxi & cab permit cover." },
  { id: "tata_ace", label: "Tata Ace", desc: "Small commercial goods-carrier cover." },
  { id: "bolero_pickup", label: "Bolero Pickup", desc: "Pickup & light commercial vehicle cover." },
];

export const STATUS_META = {
  pending: { label: "Pending", color: "#FFB020" },
  dispatched: { label: "Dispatched", color: "#007AFF" },
  on_the_way: { label: "On the way", color: "#8B5CF6" },
  completed: { label: "Completed", color: "#22C55E" },
  cancelled: { label: "Cancelled", color: "#A0A0A0" },
};
